import { useNavigate } from "react-router-dom";
import Cupones from "../../page/cupones/Cupones";
import { useContext, useEffect, useState } from "react";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import { authContext } from "../../../../context/auth/AuthContext";

const CuponesController = () => {
  const navigate = useNavigate();
  const { user } = useContext(authContext);
  const { data } = user;

  const [cupones, setCupones] = useState(null);
  const [filter, setFilter] = useState({
    sort: 'id',
    ['filter[status]']: 'ACTIVO'
  });
  let controller;

  const onClick = (e, value) => {
    switch (e.target.name) {
      case "añadir-cupon":
        {
          return navigate(`/dashboard/cupones/nuevo`);
        }
        break;
      case "editar-cupon":
        {
          return navigate(`/dashboard/cupones/${value}`);
        }
        break;
    }
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      case "":
        {
        }
        break;
    }
  };
  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (!cupones) {
      let params = {
        ...filter,
      };
      return fetch(setCupones, params, "/cupones");
    }
  }, []);

  return (
    <Cupones
      filter={filter}
      setFilter={setFilter}
      fetch={fetch}
      data={cupones ?? { data: [], links: [] }}
      setData={setCupones}
      onChange={onChange}
      onClick={onClick}
      navigate={navigate}
      user={data}
    />
  );
};

export default CuponesController;
